const utils = require('../../../lib/utils')

module.exports = {
	events: {
		handleValueChanges: {
			type: 'change',
			selector: 'input',
			action: function(event){
				var self = event.data.component;
				if(self.model.isMultiCheckbox){
					event.stopImmediatePropagation();
					event.preventDefault();

					var $target = $(event.target).closest('input');
					if(self.setValue($target)){
						self.triggerClosest('onChildChanged', {
							fieldCode: 	self.model.fieldCode,
							value: 		self.model.dataJSON
						});
					}
				}
			}
		}
	},

	methods: {
		prepare: function(){
			this.model.isMultiCheckbox = String((this.model.atom || {}).dataType).match(/-picker$/) !== null;
		},

		setValue: function($input){
			if(this.model.isMultiCheckbox){
				// init
				var value 				= $input.data('value');
				var valueIndex 			= utils.indexOf(this.model.dataJSON, value);
				var hasValueChanged 	= false;
				var checkboxIsChecked 	= $input.is(':checked')

				// defaults
				if(this.model.dataJSON === undefined){
					this.model.dataJSON = [];
					hasValueChanged = true;
				}

				// add or remove value
				if(valueIndex >= 0 && !checkboxIsChecked){
					// delete this.model.dataJSON[valueIndex];
					this.model.dataJSON.splice(valueIndex, 1);
					hasValueChanged = true;
				} else if (valueIndex < 0 && checkboxIsChecked) {
					// this.model.dataJSON[utils.collectionSize(this.model.dataJSON)] = value;
					this.model.dataJSON.push(value);
					hasValueChanged = true;
				}

				return hasValueChanged;
			}

			console.error('single value checkboxes do not support the setValue function!');
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(self.model.isMultiCheckbox){
				// fill default values if necessary
				var someValueChanged = false;
				$element.find('input').each(function(elementIndex, input){
					someValueChanged = someValueChanged || self.setValue($(input));
				});

				if(someValueChanged){
					self.triggerClosest('onChildChanged', {
						fieldCode: 	self.model.fieldCode,
						value: 		self.model.dataJSON
					});
				}
			}
		}
	}
}